function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M17.5 21h-11a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v14a2 2 0 01-2 2z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M14 7.5h2m-2 3h2M8 15h8m-8 3h8M9.5 6.75V6m0 5.25V12m-1.302-1.286c.194.318.526.538.927.538h.822a1.053 1.053 0 00.256-2.075l-1.406-.352a1.055 1.055 0 01.256-2.075h.822c.4 0 .731.219.925.536"
}));